import { render } from "./CatalogFinishing.vue?vue&type=template&id=771bb974"
import script from "./CatalogFinishing.vue?vue&type=script&lang=js"
export * from "./CatalogFinishing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__